import PitchCall from "../../enums/PitchCall.js";

const couldClassifyAsBattedBallEvent = function(pitchCall) {
    switch (pitchCall) {
        case PitchCall.BallInPlay.key:
        case PitchCall.FoulBall.key:
        case PitchCall.FoulBunt.key:
        case PitchCall.FoulTip.key:
        //case PitchCall.Unidentified.key: // TODO - not sure about this one ?
            return true;

        default:
            return false;
    }
};

export default couldClassifyAsBattedBallEvent;